import Modal from "./modal";
import Utils from "./utils";

export default class IframeModal extends Modal {
  #url;
  #status = {};

  async open(title, url) {
    const baseUrl = window.location.origin;
    this.#url = new URL(url, baseUrl);
    this.#bindEvents();
    const $content = this.#getIframe(this.#url.href);
    this.setContent(title, $content);
    await super.open();
  }

  #getIframe(href) {
    const $iframe = $(`<iframe class="row mx-auto" allow="payment"></iframe>`);
    const cleanHref = DOMPurify.sanitize(href);
    $iframe.attr("src", cleanHref);
    return $iframe;
  }

  async awaitSuccessStatus() {
    if ($.isEmptyObject(this.#status)) {
      // Wait for a status message
      let waiting = true;
      while (waiting) {
        // eslint-disable-next-line no-await-in-loop
        await this.#getStatus();
        waiting = false;
      }
    }

    // Handle an error status
    if (this.#status.status !== "success") {
      const message = this.#status.message;
      this.#resetStatus();

      throw new Error(message);
    }

    // Otherwise, success!
  }

  #bindEvents() {
    // Process events from window messages
    this.#resetStatus();

    const windowMessageHandler = (e) => {
      const { data, origin } = e.originalEvent;

      // Only action window messages from the iframe origin
      if (origin === this.#url.origin) {
        // Trigger corresponding events
        if ("status" in data) {
          this.#status = {
            status: data.status,
            message: data.message
          }

          this.eventTarget.triggerHandler("status");
        }
      }
    };

    // Toggle off/on to ensure bound only once
    $(window).off("message", windowMessageHandler).on("message", windowMessageHandler);
  }

  #resetStatus() {
    this.#status = {};
  }

  async #getStatus() {
    return Utils.promisifyEvent(this.eventTarget, "status", this.abortController.signal);
  }
}
